import React, { useEffect } from "react";
import "./dashboard.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMerchantMostPopularOffer,
  fetchNewCustomerOffers,
  fetchofferRedeemPercentage,
  fetchOfferViewsClicks,
  getAboutPageViews,
  getDashboardStats,
  getFavouriteOffers,
  getRedeemedFrequencies,
  getRedemptionByDemographics,
  getRedemptionRates,
} from "../../../services/merchantService";
import CustomerAcquisitionMetrics from "../../Charts/CustomerAcquisitionMetrics";
import Saves from "../../Charts/Saves";
import VoucherRedemptionRate from "../../Charts/VoucherRedemptionRate";
import AveragePurchaseFrequency from "../../Charts/AveragePurchaseFrequency";
import OfferClicksAndViews from "../../Charts/OfferClicksAndViews";
import AboutPageViews from "../../Charts/AboutPageViews";
import RegionMap from "../../Maps/RegionMap";

const isBlockedMerchantStatus = (merchant) =>
  ["disabled", "deleted", "declined", "rejected"].includes(
    String(merchant?.status || "").toLowerCase()
  );

// Dedupe rapid re-fetches (e.g., StrictMode double-invoke in dev, quick remounts)
const merchantDashboardFetchCache = new Map();
const DASHBOARD_FETCH_COOLDOWN_MS = 2500;

const Summary = () => {
  const dispatch = useDispatch();
  const selectedmerchant = useSelector(
    (state) => state.merchantReducer.selectedMerchent
  );
  const selectedMerchantId = selectedmerchant?._id || selectedmerchant?.id || null;

  useEffect(() => {
    if (isBlockedMerchantStatus(selectedmerchant)) return;
    if (!selectedMerchantId) return;

    const cacheKey = `merchant-dashboard:${selectedMerchantId}`;
    const now = Date.now();
    const lastFetchedAt = merchantDashboardFetchCache.get(cacheKey) || 0;
    if (now - lastFetchedAt < DASHBOARD_FETCH_COOLDOWN_MS) return;
    merchantDashboardFetchCache.set(cacheKey, now);

    // Fetch all required data for the dashboard charts
    dispatch(fetchOfferViewsClicks());
    dispatch(getFavouriteOffers());
    dispatch(getAboutPageViews());
    dispatch(getDashboardStats());
    dispatch(getRedemptionByDemographics());
    dispatch(getRedemptionRates({ timePeriod: "lastYear" }));
    dispatch(getRedeemedFrequencies({ timePeriod: "lastYear" }));
    dispatch(fetchNewCustomerOffers());
  }, [dispatch, selectedMerchantId, selectedmerchant?.status]);

  return (
    <>
      <div className="mt-4 grid lg:grid-cols-2 grid-cols-1 gap-4 w-full">
        <VoucherRedemptionRate />
        <AveragePurchaseFrequency />
        <CustomerAcquisitionMetrics />
        <OfferClicksAndViews />
        <Saves />
        <AboutPageViews />
      </div>
      <div className="mt-4">
        <RegionMap />
      </div>
    </>
  );
};

export default Summary;
